import "rxjs/add/operator/map";
import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events } from 'ionic-angular';
import { GlobalConfig } from './app.config';
import { HomePage } from '../pages/home/home';
import { Splash } from '../pages/splash/splash';
import { LandingPage } from '../pages/landing/landing';
import { EventPage } from '../pages/event/event';
import { RoomPage } from '../pages/room/room';
import { AuthData } from '../providers/auth';

@Component({
  templateUrl: 'app.html'
})

export class RebusApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LandingPage;
  eventList: any;
  client: any;
  displayMenu: any = false;
  eventActivate: any = false;

  constructor(public platform: Platform, public auth: AuthData, events: Events, translate: TranslateService) {

    translate.setDefaultLang(GlobalConfig._defaultLang);

    events.subscribe('client:event-selected', (event) => {
      this.displayMenu = true;
      this.changeRootEvent(event);
    });

    events.subscribe('client:list-events', (listEvents, client) => {
      listEvents.then(data => {
        this.eventList = data;
        this.client = client;

        if (!GlobalConfig._isOneClient) {
          this.nav.setRoot(Splash, {client: this.client})
        }

        setTimeout(() => {
          this.eventList.forEach((childSnap) => {
            if (childSnap.isDefault) {
              if (this.client.permissions.defaultPage == 'EventPage') {
                this.displayMenu = true;
                this.changeRootEvent(childSnap);
              } else if (this.client.permissions.defaultPage == 'RoomPage') {
                this.displayMenu = false;
                this.nav.setRoot(RoomPage, {client: this.client, eventList: this.eventList});
                // this.changeRootEvent(childSnap);
              } else if (this.client.permissions.defaultPage == 'HomePage') {
                this.displayMenu = false;
                this.nav.setRoot(HomePage, {client: this.client, event: childSnap});
              }
            }
          });

          if (this.client.permissions.defaultPage == 'HomePage') {
            this.displayMenu = false;
            this.nav.setRoot(HomePage, {client: this.client, event: false});
          }

        // }, GlobalConfig._isOneClient ? 4000: 3000); // Timeout del splah
        }, GlobalConfig._isOneClient ? 2500: 2500); // Timeout del splah

        // Registration gcm for chrome users
        // const dataRegister: any = document.getElementById('registrationId');
        // this.auth.saveGcm(dataRegister.value, this.client, childSnap);
      });

    });

    events.subscribe('client:go-event', (event) => {
      this.displayMenu = true;
      this.changeRootEvent(event);
    });
  }

  changeRootEvent(event) {
    this.eventActivate = event;

    this.nav.setRoot(EventPage, {
      event: this.eventActivate,
      eventName: event.title,
      eventList: this.eventList,
      client: this.client
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/app/app.component.ts